<template>
    <div class="main">
        <div class="maintitle">
            <van-nav-bar :title="title" left-arrow @click-left="onClickLeft" />
        </div>
        <div class="main_content">
            <div class="content" v-html="explainContent">
            </div>
        </div>
    </div>
</template>
<script>
import { explainsettingModule } from "../request/myFreecharge";
import { Toast } from 'vant';
export default {
    data () {
        return {
            explainContent: '',
            title: ''
        }
    },
    created: async function () {
        await this.getInfo()
    },
    methods: {
        onClickLeft () {
            this.$router.go(-1)
        },
        async getInfo () {
            await explainsettingModule.explainsettingdetailshare(this.$route.query.explainID).then((response) => {
                // console.log(response)
                switch (response.data.code) {
                    case 100:
                        this.explainContent = response.data.result.explainContent
                        this.title = response.data.result.explainTitle
                        break;
                    case 101:
                        Toast({
                            message: "获取失败",
                            position: 'center',
                        });
                        break;
                    case 100001:
                        Toast({
                            message: "网络接连异常，请稍后再试",
                            position: 'center',
                        });
                        break;
                }
            }).catch(() => { })
        },
    },
}
</script>
<style scoped>
.main {
  width: 100%;
  background: #ffffff;
  height: 100%;
}
.maintitle {
  width: 100%;
  position: fixed;
  z-index: 222;
  /* min-height: 100%; */
}
.maintitle >>> .van-nav-bar .van-icon {
  color: #333;
}
.maintitle >>> .van-nav-bar__arrow {
  font-size: 0.633rem;
}
.maintitle >>> .van-nav-bar__title {
  font-size: 0.48rem;
  font-weight: 700;
  color: #1a1a1a;
}
.main_content {
  padding-top: 1.5rem;
  /* padding-bottom: 0.5rem; */
  width: 100%;
  background: #ffffff;
  height: 100%;
  box-sizing: border-box;
}
.content {
  width: 9.2rem;
  margin: 0 auto;
  font-weight: 500;
  height: 100%;
  /* padding: 0.4rem; */
}
.title {
  font-size: 0.373rem;
  color: #2f2f2f;
  font-weight: 700;
}
.time {
  font-size: 0.32rem;
  color: #969696;
  margin-top: 0.666rem;
}
.text {
  font-size: 0.32rem;
  color: #969696;
  margin-top: 0.56rem;
}
</style>